// extracted by mini-css-extract-plugin
export default {"container":"CalculationBatchMenu_container__tiPCU","sideBar":"CalculationBatchMenu_sideBar__lpzJM","panel":"CalculationBatchMenu_panel__T3AKN"};